<a routerLink="/sustainability/{{dataAspect?.slug}}" class="card-aspect text-center">
    <div class="icon-pict">
        <img [src]="apiAsset + dataAspect?.icon" class="w-100" alt="">
    </div>
    <p class="tit-f18b mt-3">{{ dataAspect?.title }}</p>
</a>